// Create new Locker instance
export const storage = new Locker();

export const retrieveHistory = () => {
	let chatHistory = storage.retrieve("history2");

	if (!!chatHistory) {
		return chatHistory;
	} else {
		let oldChatHistory = storage.retrieve("history");

        if (!!oldChatHistory) {
            storage.store("history2", oldChatHistory);
            return oldChatHistory;
        } else {
            return [];
        }
	}
}

export const setHistory = (chatHistory) => {
	storage.store("history2", chatHistory);
}


// WEBPACK FOOTER //
// ./src/services/storage.js